<template>
  <div>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px" v-if="!consejeria">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Registro</v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span v-show="!editingBitacora" class="headline">Nueva Bitácora</span>
                    <span v-show="editingBitacora" class="headline">Editar Bitácora</span>
                </v-card-title>
                <v-card-text>

                  <text-area-input
                    :form="form"
                    :label="$t('admissions.settings.form.description')"
                    :v-errors="errors"
                    :value.sync="form.description"
                    name="description"
                    v-validate="'required'"
                  ></text-area-input>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close">{{$t('admissions.settings.form.cancel')}}</v-btn>
                    <v-btn v-if="!editingBitacora" color="blue darken-1" flat @click="saveBitacora">{{$t('admissions.settings.form.save')}}</v-btn>
                    <v-btn v-else color="blue darken-1" flat @click="updateBitacora">{{$t('admissions.settings.form.update')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-toolbar>
    <v-card>
      <v-card-title>
        Bitácora
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="bitacora"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.created_at }}</td>
          <td class="text-xs-center">{{ props.item.user.name }}</td>
          <td class="text-xs-center">{{ props.item.description }}</td>
          <td class="text-xs-center">
            <v-tooltip top v-if="!consejeria">
              <v-icon
                medium
                class="mr-2"
                @click="editBitacora(props.item.id)"
                slot="activator"
              >
                edit
              </v-icon>
              <span>{{$t('admissions.entries.edit')}}</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import Form from 'vform'
  export default {
    name: 'admissions-bitacora',
    props: {
      bitacora: {
        type: Array,
        required: true
      },
      family_id: {
        type: String,
      },
      consejeria: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        dialog: false,
        editingBitacora: false,
        headers: [
          { text: 'Fecha', value: 'created_at', align: 'center' },
          { text: 'Usuario', value: 'family.user.name', align: 'center' },
          { text: 'Descripcion', value: 'description', align: 'center' },
          { text: 'Acciones', value: 'protein', align: 'center' },
        ],
        form: new Form({
          family_id: this.$props.family_id,
          description: ''
        })
      }
    },
    watch: {
      dialog(val) {
        val || this.close()
      }
    },
    methods: {
      close() {
        this.form = new Form({
          family_id: this.$props.family_id,
          description: '',
        })
        this.dialog = false
        this.editingBitacora = false
      },
      editBitacora(id) {
        const BitacoraToEdit = this.bitacora.filter(type => type.id === id)[0];
        this.editingBitacora = true;
        this.dialog = true;
        this.form = new Form({
          family_id: BitacoraToEdit.family_id,
          description: BitacoraToEdit.description,
          id: BitacoraToEdit.id
        });

      },
      saveBitacora() {
        this.form.family_id = this.$props.family_id;
        this.form.post('/api/admissions/bitacora')
          .then(resp => {
            if (resp.status === 200) {
              this.$store.dispatch('responseMessage', {
                type: 'success',
                text: 'Registro creado con éxito',
                modal: false
              })
              this.$emit('fetchBitacora')
              this.close()
            }
          })
          .catch(error => console.log(error));
      },
      updateBitacora() {
        this.form.put('/api/admissions/bitacora')
          .then(resp => {
            if (resp.status === 200) {
                this.$emit('fetchBitacora')
                this.close()
                this.editingBitacora = false;
            }
          })
          .catch(error => console.log(error));
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/bitacora.vue